export default {
    edit: 'Edit',
    delete: 'Delete',
    deletion: {
        title: 'Delete company micro-trend "{title}"?',
        content: 'The company-micro-trend will be deleted for all participants.',
        notice: 'Note: This action cannot be undone.',
        confirm: 'Yes, delete now',
        success: 'The company-micro-trend was successfully deleted.'
    }
}
